/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 */
import * as QA from '../../utils/qa';

const DesktopOnlyItemIds: [string] = [QA.ACTION_PRINT];

export function removeDesktopOnlyNoteActionItems(item: { id: string }) {
  return item && !DesktopOnlyItemIds.includes(item.id);
}
